<template>
  <div>
    <div v-if="state === 'initializing'">
      {{ $t('loading…') }}
    </div>
    <div v-else>
      <div class="list-group">
        <a href="#"
            class="list-group-item list-group-item-action"
            v-for="(activity, index) in activityAndVariantsList" :key="index"
            @click.prevent="openModal(activity.id)">
          <div class="d-flex w-100 justify-content-between">
            <p class="mb-1"><strong>{{ activity.code }}</strong></p>
          </div>
          <p v-if="activity.variantsList.length === 1" class="mb-1">
            <small>{{ activity.variantsList.length }} / {{ activity.variantsTotal }} variant selected</small>
          </p>
          <p v-else class="mb-1">
            <small>{{ activity.variantsList.length }} / {{ activity.variantsTotal }} variants selected</small>
          </p>
        </a>
    </div>
      <div class="mt-2">
        <button type="button" class="btn btn-outline-primary" @click="openModal(0)">
          {{ $t('Select variant(s)') }}
        </button>
      </div>
    <VariantsSelectModal
        :activities-select-list="activitiesSelectList"
        :variants-selected="variantsSelected"
        @send-variants-list="variantsSelected = $event; showModal = false"
        @modal-close="showModal = false"
        :activity-default="activityDefault"
        :showModal="showModal"
    ></VariantsSelectModal>
  </div>
  <input type="hidden" :value="JSON.stringify(variantsSelected)" :name="fieldName">
  </div>
</template>

<script>
import VariantsSelectModal from "./VariantsSelectModal.vue";

export default {
  components: {
    VariantsSelectModal,
  },
  props: {
    activitiesUrl: {
      required: true,
      type: String,
    },
    activityVariantsInRule: {
      type: Array,
      default: function () {
        return []
      }
    },
    activities: {
      required: true,
      type: Array,
    },
    label: {
      required: true,
      type: String,
    },
    criteriaSelected: {
      required: true,
      type: String,
    },
    fieldName: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      variantsSelected: [],
      activitiesSelectList: {},
      state: 'initializing',
      activityDefault: 0,
      showModal: false,
    }
  },
  computed: {
    activityAndVariantsList() {
      let vm = this
      if (this.variantsSelected) {
        return this.activities.reduce(function (accu, activity) {
          let variantArr = activity.activity_variants.filter(function (variant) {
            return vm.variantsSelected.includes(variant.id)
          });
          let data = {
            "id" : activity.id,
            "code": activity.code,
            "variantsList": variantArr,
            "variantsTotal": activity.activity_variants.length
          };
          if (data.variantsList.length > 0) {
            accu.push(data);
          }
          return accu
        }, [])
      }
    }
  },
  methods: {
    getCatalog: async function () {
      try {
        this.state = 'initializing';
        const {data} = await axios.get(this.activitiesUrl)
        this.state = 'idle';
        this.activitiesSelectList = data.data;
        this.activitiesSelectList = this.activitiesSelectList.reduce(
            function (accu, activity) {
              accu.push(activity);
              activity.associated_activities.forEach(
                  (associated_activity) => accu.push(associated_activity));
              return accu
            }, []);
      } catch (e) {
        alert(e.message)
      }
    },
    openModal: function(id) {
      this.showModal = true
      this.activityDefault = id
    },
  },
  watch: {
    criteriaSelected: function (val) {
      if (val === "all") {
        this.variantsSelected = []
      }
    }
  },
  mounted() {
    this.variantsSelected = this.activityVariantsInRule
    this.getCatalog()
  }
}
</script>

<style scoped>

</style>
